/* pb-fs-threshold-ab.js
 * Front-end for the free-shipping-threshold A/B test (Convert experiment 100142753).
 *
 *   Control  (variation 1001223190) = free shipping from €30  -> server-rendered
 *            default, left untouched.
 *   Variant B(variation 1001223191) = free shipping from €45  -> applied here,
 *            client-side, for variant-B visitors only.
 *
 * The Shopify delivery function already shows/hides the paid rate per variant
 * (via the `variation_100142753` cart attribute). This script only keeps the
 * *marketing copy* in sync for variant-B visitors:
 *   - top-bar announcement(s)                       (sections/header-group.json)
 *   - product-page / LP free-shipping banners       (mobile_carousel_banner_text, LP text)
 *   - the "Gratis verzending vanaf €30" info-icon   (custom.info_icons metaobject
 *                                                    -> blocks/ai_gen_block_00f176d.liquid)
 *   - the cart-drawer free-shipping progress tier   (threshold 30 -> 45)
 *
 * Detection mirrors sections/pb-pick-mix-bundle-AB-testing.liquid:
 *   `?convert_v=` URL override for preview, else window.convert.currentData.
 *
 * NOTE: the variant is only known client-side, so variant-B visitors briefly see
 * €30 before the swap (unavoidable without server-side bucketing). Control sees
 * nothing change.
 */
(function () {
  'use strict';

  var EXPERIMENT_ID = '100142753';
  var VARIANT_B_ID  = '1001223191';
  var TO            = '45'; // control amount (30) is the server-rendered default

  // ---- variant detection -------------------------------------------------
  function convertVariationId() {
    try {
      var forced = new URLSearchParams(window.location.search).get('convert_v');
      if (forced) return String(forced);
      var cd = window.convert && window.convert.currentData;
      if (!cd) return '';
      var e = (cd.experiences && cd.experiences[EXPERIMENT_ID]) ||
              (cd.experiments && cd.experiments[EXPERIMENT_ID]);
      if (!e) return '';
      return String((e.variation && e.variation.id) || e.variation_id || e.variationId || '');
    } catch (err) { return ''; }
  }
  function isVariantB() { return convertVariationId() === VARIANT_B_ID; }
  function convertReady() {
    // Once Convert has loaded its data, an empty experiment list is a real
    // "not in this test" answer rather than "not loaded yet".
    if (new URLSearchParams(window.location.search).get('convert_v')) return true;
    return !!(window.convert && window.convert.currentData);
  }

  // ---- text swap (top bar, banners, info-icon caption) -------------------
  // Only touch text nodes that are free-shipping copy AND mention 30, then swap
  // the "€30" amount to "€45". The phrase guard keeps unrelated "€30" (e.g. a
  // product price) untouched.
  var SHIP_RE   = /(gratis\s*verzending|verzending\s*(?:v\.?\s*a\.?|vanaf)|free\s*shipping)/i;
  var AMOUNT_RE = /(€\s*)30\b/g;

  function swapOneTextNode(node) {
    var v = node.nodeValue;
    if (!v || v.indexOf('30') === -1 || !SHIP_RE.test(v)) return;
    var next = v.replace(AMOUNT_RE, '$1' + TO);
    if (next !== v) node.nodeValue = next;
  }

  function swapTextIn(root) {
    if (!root || !root.nodeType) return;
    if (root.nodeType === 3) { swapOneTextNode(root); return; }
    if (root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var v = node.nodeValue;
        if (!v || v.indexOf('30') === -1) return NodeFilter.FILTER_REJECT;
        return SHIP_RE.test(v) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT;
      }
    });
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(swapOneTextNode);
  }

  // ---- cart-drawer free-shipping tier (threshold 30 -> 45) ---------------
  function patchCartTier() {
    var tiers = document.querySelectorAll('[data-tier][data-reward-type="free_shipping"]');
    var patched = false;
    tiers.forEach(function (t) {
      if (t.dataset.threshold !== TO) { t.dataset.threshold = TO; patched = true; }
    });
    if (!patched) return;
    // Force assets/cart-progress-bar.js to rebuild with the new threshold. It
    // rebuilds when the tier-threshold "key" changes, so we clear its build flag
    // and replay the app's normal cart-updated event with the current cart.
    var bar = document.getElementById('CartProgressBar');
    if (bar) bar.dataset.built = '';
    try {
      if (window.PBCart && window.PBCart.current) {
        window.PBCart.current().then(function (cart) {
          document.dispatchEvent(new CustomEvent('pb:cart:updated', { detail: { source: 'fs-ab', cart: cart } }));
        }).catch(function () {});
      }
    } catch (e) {}
  }

  // ---- cart free-shipping banner amount ---------------------------------
  // The drawer renders "…vanaf €<span class="ucd-free-ship-banner__amount">30</span>",
  // so the amount lives in its own element (isolated from the phrase). Patch it
  // directly. Idempotent: once it reads 45 there is no "30" left to match.
  function patchShipAmounts() {
    var spans = document.querySelectorAll('.ucd-free-ship-banner__amount');
    for (var i = 0; i < spans.length; i++) {
      var s = spans[i];
      if (/\b30\b/.test(s.textContent)) s.textContent = s.textContent.replace(/\b30\b/, TO);
    }
  }

  // ---- keep the cart attribute in sync so checkout matches the copy ------
  // The theme's own writer (pbEnsureFirstTouchOnCart) only writes
  // variation_<expId> from window.convert.currentData, so a ?convert_v= forced
  // preview never reaches the delivery function. Write it ourselves whenever we
  // detect variant B, so the shown €45 and the checkout behaviour always agree.
  var ATTR_KEY = 'variation_' + EXPERIMENT_ID;
  var attrEnsured = false;
  function ensureCartAttribute() {
    if (attrEnsured) return;
    if (!window.PBCart || !window.PBCart.current || !window.PBCart.setAttributes) return; // retry next tick
    attrEnsured = true;
    try {
      window.PBCart.current().then(function (cart) {
        var attrs = (cart && cart.attributes) || [];
        var ok = attrs.some(function (a) { return a.key === ATTR_KEY && a.value === VARIANT_B_ID; });
        if (!ok) {
          var patch = {}; patch[ATTR_KEY] = VARIANT_B_ID;
          return window.PBCart.setAttributes(patch);
        }
      }).catch(function () { attrEnsured = false; });
    } catch (e) { attrEnsured = false; }
  }

  // ---- apply + keep applied ----------------------------------------------
  var observing = false;
  function apply() {
    swapTextIn(document.body);
    patchShipAmounts();
    patchCartTier();
    ensureCartAttribute();
    if (observing) return;
    observing = true;
    // Re-apply to dynamically rendered content: cart drawer, marquee clones,
    // late-loading product/LP sections.
    var obs = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'characterData') {
          // e.g. cart-progress-bar.js restoring "…vanaf €30" on each cart update
          swapOneTextNode(m.target);
          continue;
        }
        var added = m.addedNodes;
        for (var j = 0; j < added.length; j++) {
          var nt = added[j].nodeType;
          if (nt === 1 || nt === 3) swapTextIn(added[j]); // element or text node
        }
      }
      patchShipAmounts();
      patchCartTier();
      ensureCartAttribute();
    });
    obs.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  // ---- boot: wait for Convert, then decide -------------------------------
  function boot() {
    var tries = 0, MAX = 40; // ~8s at 200ms
    (function poll() {
      if (isVariantB())   { apply(); return; }  // variant B -> apply €45 copy
      if (convertReady()) { return; }           // control / not in test -> keep €30
      if (++tries >= MAX) { return; }           // Convert never resolved -> safe default
      setTimeout(poll, 200);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // debug hook: window.PB_FS_AB.isVariantB() / .apply()
  window.PB_FS_AB = { variationId: convertVariationId, isVariantB: isVariantB, apply: apply };
})();
